import jwt from 'jwt-decode';

export const getUser = (token: string | null) => {
  if (!token) {
    return;
  } else {
    const user = jwt(token);
    return user;
  }
}

export const getAccessToken = () => {
  return localStorage.getItem('admin-access-token')
}

export const getRefreshToken = () => {
  return localStorage.getItem('admin-refresh-token')
}

export const setAccessToken = (token: string) => {
  return localStorage.setItem('admin-access-token', token)
}

export const setRefreshToken = (token: string) => {
  return localStorage.setItem('admin-refresh-token', token)
}

export const clearAccessToken = () => {
  return localStorage.removeItem('admin-access-token')
}

export const clearRefreshToken = () => {
  return localStorage.removeItem('admin-refresh-token')
}
